import React from 'react';
import { useTranslation } from 'react-i18next';

import {
    Person as PersonIcon,
    Email as EmailIcon,
    Phone as PhoneIcon,
    Business as BusinessIcon,
    CalendarToday as DateIcon,
    Description as PurposeIcon,
    Badge as BadgeIcon,
    Engineering as EquipmentIcon,
} from '@mui/icons-material';

import CustomCard from '../../../../../components/CustomCard';
import RowCardText from '../../../../../components/RowCardText';

import DivContainerBody from '../../../../../components/DivContainerBody';
import CustomChip from '../../../../../components/CustomChip';
import { statusColor } from '../../../../../enums/statusColorEnum';
import {EMPTY_VALUES, getDateFormat, getFullName} from '../../../../../Apis/functions';
import HeadTittle from '../../../../../components/HeadTittle';
import { status } from '../../../../../enums/statusEnum';
import InvitationDetailsApp from "../Functionality/InvitationDetailsApp";
import {getFieldTypeById} from "../../Type/Model/Model";

/**
 * @Email : aullah@ibl.mx
 * @Author: abaid
 * @jobTittle: Full Stack Developer
 * @returns {JSX.Element}
 * @constructor
 */
const InvitationDetails = () => {
    const { t } = useTranslation();
    const { getInvitationById } = InvitationDetailsApp();

    return (
        <>
            {/* Header with Back Button */}
            <HeadTittle name={'details'} onBack={true} hidden={false}/>
            <DivContainerBody>
                {/* Main Content */}
                <div className='row'>
                    {/* Basic Information */}
                    <div className='col-md-6'>
                        <CustomCard classes='h-100' title={t('basic_information')}>
                            <RowCardText
                                title={t('name')}
                                value={
                                    getFullName(
                                        getInvitationById?.invitation?.hostName,
                                        getInvitationById?.invitation?.hostLastName,
                                        getInvitationById?.invitation?.hostSecondLastName,
                                    ) || EMPTY_VALUES.DEFAULT
                                }
                                icon={<PersonIcon />}
                            />

                            <RowCardText
                                title={t('visit_date')}
                                value={`${getDateFormat(getInvitationById?.invitation?.startDate)}-${getDateFormat(
                                    getInvitationById?.invitation?.endDate,
                                )}`}
                                icon={<DateIcon />}
                            />
                            <RowCardText
                                title={t('zone')}
                                value={getInvitationById?.invitation?.zoneName || '--'}
                                icon={<PurposeIcon />}
                            />
                            <RowCardText
                                title={t('status')}
                                html={
                                    <CustomChip
                                        legend={t(status[getInvitationById?.invitation?.statusId])}
                                        background={statusColor[getInvitationById?.invitation?.statusId]}
                                    />
                                }
                            />
                        </CustomCard>
                    </div>

                    {/* Visit Information */}
                    <div className='col-md-6'>
                        <CustomCard classes='h-100' title={t('visit_information')}>
                            <RowCardText
                                title={t('name')}
                                value={getInvitationById?.invitation?.visitorName || '--'}
                                icon={<BusinessIcon />}
                            />
                            <RowCardText
                                title={t('email')}
                                value={getInvitationById?.invitation?.visitorEmail || '--'}
                                icon={<EmailIcon />}
                            />
                            <RowCardText
                                title={t('phoneNumber')}
                                value={getInvitationById?.invitation?.visitorPhoneNumber || '--'}
                                icon={<PhoneIcon />}
                            />

                            <RowCardText
                                title={t('visitor_type')}
                                value={getInvitationById?.invitation?.visitorType?.name || '--'}
                            />
                        </CustomCard>
                    </div>

                    {/* Additional Information */}
                    <div className='col-md-12 mt-5'>
                        <CustomCard classes='' title={t('additional_information')}>
                            {getInvitationById?.fields?.map((field) => (
                                <RowCardText
                                    key={field.id}
                                    title={t(field.fieldName?.toLowerCase())}
                                    value={ getFieldTypeById(field.id)?.name || '--'}
                                    icon={field.id === 'badgeRequired' ? <BadgeIcon /> : <EquipmentIcon />}
                                />
                            ))}
                        </CustomCard>
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default InvitationDetails;
